import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {generateCopyLink} from '../../ClientJourneyTask.util';
import {styles} from '../TaskDetails.style';

export const HealthAssessmentTaskDetails = ({lastPaidRank}: any) => {
  const {ts} = useTranslation(
    'clientProfile.clientJourney.preJourney.healthAssessment',
  );

  return (
    <>
      <View style={styles.preJourneyTaskDetailContent}>
        <Text
          variant="button"
          style={styles.taskDetailText}
          onPress={generateCopyLink('external_link', lastPaidRank)}
          {...testProperties(DownlineProfile.cjTaskDetailsLink, true)}>
          {ts('assessmentdetails', 'View Health Assessment Online')}
        </Text>
        <TouchableOpacity
          onPress={generateCopyLink('copy_external_link', lastPaidRank)}>
          <Icon style={styles.copyIcon} name="copy" accessible={false} />
        </TouchableOpacity>
      </View>

      <View style={styles.taskContentText}>
        <Text
          style={styles.taskDetailContentText}
          {...testProperties(DownlineProfile.cjTaskDetailsText)}>
          {ts(
            'assessmentdetails',
            "Organize your Client's Health Assessment - which can be hard copies in your binder or digital copies on your device.",
          )}
        </Text>
      </View>
    </>
  );
};
